import { ArrowRight } from "lucide-react";
import { useSelector } from "react-redux";

export const Hero = () => {
  const company = useSelector((state) => state.company);

  return (
    <section
      id="beranda"
      className="relative h-screen flex items-center justify-center bg-gradient-to-br from-pink-300 via-rose-300 to-purple-400 overflow-hidden"
    >
      <div className="absolute inset-0 bg-black opacity-30"></div>
      <div className="absolute inset-0 opacity-20">
        <img
          src="pic9.png"
          alt="Hero Background"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 text-center text-white px-4 max-w-5xl mx-auto">
        <div className="mb-6">
          <img
            src="/logo2.png"
            alt="logo"
            className="h-40 w-40 mx-auto mb-4 animate-bounce"
          />
        </div>
        <h1 className="text-5xl md:text-7xl font-bold mb-6">{company.name}</h1>
        <p className="text-xl md:text-3xl mb-4 font-light">{company.tagline}</p>
        <p className="text-lg md:text-xl mb-8 max-w-3xl mx-auto opacity-90">
          Handmade dengan Cinta dari Bali
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="#produk"
            className="bg-white text-pink-600 px-8 py-4 rounded-full font-semibold hover:bg-pink-50 transition-all transform hover:scale-105 inline-flex items-center justify-center shadow-lg"
          >
            Lihat Produk <ArrowRight className="ml-2 h-5 w-5" />
          </a>
          <a
            href="#kontak"
            className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold hover:bg-white hover:text-pink-600 transition-all transform hover:scale-105"
          >
            Hubungi Kami
          </a>
        </div>
      </div>
    </section>
  );
};
